import { useFormatCurrency } from '@/hooks/useFormatCurrency'
import { DESKTOP_QUERY, useMediaQuery } from '@/hooks/useMediaQuery'

export const HERO_SHELL =
  'rounded-2xl border border-[var(--fl-hero-border)] bg-gradient-to-br from-[var(--fl-hero-bg)] to-[var(--fl-hero-bg-2)] px-3.5 py-3 text-[var(--fl-hero-fg)] md:rounded-[20px] md:p-6'

export type HeroTone = 'income' | 'expense'

export const HERO_TONE: Record<HeroTone, string> = {
  income: 'text-[var(--fl-hero-income)]',
  expense: 'text-[var(--fl-hero-expense)]',
}

/** A phone hero is a glance, like the other pages: whole rupees. */
export function useHeroFormat() {
  const { format, formatWhole } = useFormatCurrency()
  return useMediaQuery(DESKTOP_QUERY) ? format : formatWhole
}
